import { Component } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { LabmedService } from '../../../../labmed/services/labmed.services';
import { LabmedTypeEnum } from './labmed-log.enum';

@Component({
  selector: 'app-labmed-logs',
  templateUrl: './labmed-logs.component.html',
  styleUrl: './labmed-logs.component.scss',
})
export class LabmedLogsComponent {
  logs: {
    createdBy: { firstName: string; lastName: string };
    request: any;
    response: any;
    isSuccess: boolean;
    type:LabmedTypeEnum;
    createdAt: Date;
    reqParams?: any;
    resParams?: any;
  }[];
  showLogPopup: boolean;
  activeFilter: 'all' | 'success' | 'error';
  filteredLogs: any[];
  loading: boolean = false;
  numberOfSuccess: number = 0;
  numberOfFail: number = 0;
  showNotification: boolean = false;

  constructor(
    private readonly labmedService: LabmedService,
    private readonly clipboardService: ClipboardService
  ) {}

  initilize(caseId: number) {
    this.loading = true;
    this.labmedService.getLabmedLogsByCaseId(caseId).subscribe({
      next: (res) => {
        this.logs = res ?? [];
        this.numberOfSuccess = this.getSuccessCount();
        this.numberOfFail = this.getErrorCount();
        this.activeFilter = 'all';
        this.filterLogs();
        this.showLogPopup = true;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  setFilter(filter: 'all' | 'success' | 'error') {
    this.activeFilter = filter;
    this.filterLogs();
  }

  filterLogs() {
    switch (this.activeFilter) {
      case 'success':
        this.filteredLogs = this.logs.filter((log) => log.isSuccess);
        break;
      case 'error':
        this.filteredLogs = this.logs.filter((log) => !log.isSuccess);
        break;
      default:
        this.filteredLogs = [...this.logs];
    }
  }

  getSuccessCount(): number {
    return this.logs.filter((log) => log.isSuccess).length;
  }

  getErrorCount(): number {
    return this.logs.filter((log) => !log.isSuccess).length;
  }

  toggleDetails(log: any) {
    log.showDetails = !log.showDetails;
  }


  trackByIndex(index: number): number {
    return index;
  }

  onHide() {
    this.logs = [];
    this.filteredLogs = [];
    this.numberOfSuccess = 0;
    this.numberOfFail = 0;
  }

  copySText(log: any, param: 'request' | 'response'): void {
    this.clipboardService.copyFromContent(log?.[param]);
    this.showNotification = true;
    setTimeout(() => {
      this.showNotification = false;
    }, 1000);
  }
}
